import * as Sentry from '@sentry/remix';
import { useEffect } from 'react';

async function getToken() {
  const AwsWafIntegration = window.AwsWafIntegration;

  if (!AwsWafIntegration || AwsWafIntegration.hasToken()) return;

  return AwsWafIntegration.getToken();
}

async function delayToAllowAwsWafIntegrationToLoad(attempt = 1): Promise<void> {
  if (attempt === 5) throw new Error('AwsWafIntegration not loaded');

  await new Promise((resolve) => setTimeout(resolve, 1000 * attempt));

  const AwsWafIntegration = window.AwsWafIntegration;

  if (!AwsWafIntegration)
    return delayToAllowAwsWafIntegrationToLoad(attempt + 1);
}

const useAwsGetToken = () => {
  useEffect(() => {
    window.awsWafCookieDomainList = [
      'user.thesolesupplier.co.uk',
      'thesolesupplier.co.uk'
    ];

    delayToAllowAwsWafIntegrationToLoad()
      .then(getToken)
      .catch(Sentry.captureException);

    const interval = setInterval(
      () => getToken().catch(Sentry.captureException),
      1000 * 5
    );

    return () => clearInterval(interval);
  }, []);
};

export default useAwsGetToken;
